import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';

export default class AVC extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            topButtons: [{ id: 'analizaclientilornoi', label: 'Analiza clientilor noi, loaiali si pierduti', color: '#900DCB' },
            { id: 'segmentareaclientilorcaracteristici', label: 'Segmentarea clientilor in functie de caracteristici', color: '#C8C779' },
            { id: 'analizavanzarilor', label: 'Analiza vanzarilor aditionale (cross-sell) si a profitabilitatii', color: '#59D862' },

            ],
            mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },

            ],
            listSold: { Clienti: {}, Furnizori: {} }
        }
    }

    componentDidMount() {

    }



    goTo = (id) => {
        this.props.history.push(`/${id}`)
    }
    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />

                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

                <div style={{ textAlign: 'left' }}>

                    {this.state.mapButtons.map((b, idx) => {
                        return (
                            <SiteMap
                                key={idx}
                                b={b}
                                buttonSelected={this.goTo} />

                        )
                    })}
                </div>
                <h1 className='pm-title'>Analiza de vanzari si clienti</h1>

                <Grid className='container' style={{ position: 'relative' }} container>
                    {this.state.topButtons.map((b, idx) => {
                        return (
                            <Grid key={idx} style={{ width: 'fit-content', marginTop: 10 }} className="loginButton" item xs={12} sm={12} md={4} lg={4} xl={4} >
                                {/* <Button onClick={this.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBilant}</Button>
                                <Button onClick={this.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBalanta}</Button>
                                <Button onClick={this.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaClienti}</Button>
                            */}


                                <TopButtons
                                    b={b}
                                    buttonSelected={this.goTo}
                                    buttonSelectat={this.state.buttonSelectat}
                                />





                            </Grid>
                        )

                    })}
                </Grid>
                
            </div>
        );
    }
}